import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter({ email });
      toast.success(res.message || "Subscribed");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-[#FAF4F5] border-t border-[#E8DCDD] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img
            src="/api/static/assets/8b8de18e_1msnypyd_GLS_LOGO_2_.png"
            alt="Global Leader Solutions"
            data-testid="footer-brand-logo"
            className="h-20 w-20 object-contain mb-3"
          />
          <div className="font-serif text-2xl text-[#8C4A57]">Global Leader</div>
          <div className="text-xs tracking-[0.28em] uppercase text-[#6B5E62] mt-1">Solutions</div>
          <p className="mt-4 text-sm text-[#6B5E62] leading-relaxed">
            Leadership, emotional intelligence, and conflict management education from
            Dr. Andrew Campbell.
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-sm tracking-wider uppercase text-[#2D2628] mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/ebooks" className="text-[#6B5E62] hover:text-[#8C4A57]">Ebooks</Link></li>
            <li><Link to="/courses" className="text-[#6B5E62] hover:text-[#8C4A57]">Courses</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-sm tracking-wider uppercase text-[#2D2628] mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-[#6B5E62] hover:text-[#8C4A57]">About</Link></li>
            <li><Link to="/faculty" className="text-[#6B5E62] hover:text-[#8C4A57]">Faculty</Link></li>
            <li><Link to="/media" className="text-[#6B5E62] hover:text-[#8C4A57]">Media</Link></li>
            <li><Link to="/testimonials" className="text-[#6B5E62] hover:text-[#8C4A57]">Testimonials</Link></li>
            <li><Link to="/faqs" className="text-[#6B5E62] hover:text-[#8C4A57]">FAQs</Link></li>
            <li><Link to="/contact" className="text-[#6B5E62] hover:text-[#8C4A57]">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-sm tracking-wider uppercase text-[#2D2628] mb-4">Newsletter</h4>
          <p className="text-sm text-[#6B5E62] mb-3">
            Monthly insights on leadership and human-centered management.
          </p>
          <form onSubmit={onSubmit} className="flex flex-col gap-2" data-testid="footer-newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              required
              data-testid="footer-newsletter-input"
              className="w-full px-3 py-2 text-sm bg-white border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="footer-newsletter-submit"
              className="btn-primary text-xs disabled:opacity-60"
            >
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-[#E8DCDD]">
        <div className="max-w-7xl mx-auto px-4 py-6 text-xs text-[#6B5E62] text-center">
          © {new Date().getFullYear()} Global Leader Solutions · Dr. Andrew Campbell. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
